module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', [_vm._v("I would like to thank Mission San Gabriel for its history about the Tongva. Also, special thanks to the history department at Claremont University and the good people at Fountain Valley Library. I would like to thank Holiday Inn, on Marriott Drive, Bakersfield, California. You will be seeing me again…")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2511b7ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch004.vue
// module id = 72
// module chunks = 0